var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 19,
    viewBox: "0 0 25 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.225 7.76023L16.4125 0.727416C15.45 -0.138209 13.9672 -0.0632086 13.1016 0.902416C12.2359 1.86335 12.3141 3.34617 13.2766 4.21179L16.5469 7.1571H2.34375C1.04844 7.1571 0 8.20554 0 9.50085C0 10.7962 1.04844 11.8446 2.34375 11.8446H16.55L13.275 14.7899C12.3125 15.6571 12.2344 17.1384 13.1 18.0993C13.3199 18.3438 13.5888 18.5393 13.8892 18.6731C14.1897 18.8069 14.5149 18.876 14.8438 18.8759C15.4031 18.8759 15.9641 18.6774 16.4109 18.2743L24.2234 11.2446C24.4677 11.0248 24.6631 10.7562 24.7969 10.4561C24.9307 10.1559 24.9999 9.83102 25 9.50242C24.9998 9.17397 24.9307 8.84922 24.7973 8.54913C24.6638 8.24905 24.4688 7.98029 24.225 7.76023Z",
    fill: "#0C71C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowIcon);
export default __webpack_public_path__ + "static/media/right-arrow-icon.f02444559b5fee042a9d01916e33517d.svg";
export { ForwardRef as ReactComponent };